import React, { useState } from 'react';
import { Clock } from 'lucide-react';

const DetailModalHeader = ({ closeModal, selectedProperty, t, i18n, property }) => {
  const [showLangDropdown, setShowLangDropdown] = useState(false);

  const handleShare = (property) => {
    if (!property || !property.property_id) {
      alert("ยังไม่มีข้อมูลทรัพย์สินที่จะใช้แชร์");
      return;
    }

    const shareUrl = `https://summerhousagentlive.onrender.com/share/${property.property_id}`;

    if (navigator.share) {
      navigator
        .share({
          title: property.name || document.title,
          url: shareUrl,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.log("Error sharing", error));
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("URL copied to clipboard!");
    }
  };

  // คำนวณวันโพสต์
  let diffDays = null;
  if (selectedProperty.created_at) {
    const createdDate = new Date(selectedProperty.created_at);
    const today = new Date();
    const diffTime = Math.abs(today - createdDate);
    diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'th', label: 'TH' },
    { code: 'ru', label: 'RU' },
    { code: 'zh', label: 'ZH' },
  ];

  return (
    <>
      {/* Back + Share + Language */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '1rem 2rem' }}>
        <button
          onClick={closeModal}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: '#1a2e35',
            fontWeight: '600',
            fontSize: '1.2rem',
            cursor: 'pointer',
            textDecoration: 'none',
          }}
        >
          {t("Back")}
        </button>

        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
          <button
            onClick={() => handleShare(selectedProperty)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
            }}
            title="Share this page"
          >
            <img src="share-apple.svg" alt="Share" style={{ width: '32px', height: '32px' }} />
          </button>

          {/* Dropdown เลือกภาษา */}
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setShowLangDropdown(!showLangDropdown)}
              style={{
                backgroundColor: '#1a2e35',
                color: '#fff',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '0.9rem',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0f1c20')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1a2e35')}
            >
              {i18n.language.toUpperCase()}
            </button>

            {showLangDropdown && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  right: 0,
                  background: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  overflow: 'hidden',
                  zIndex: 10,
                  minWidth: '80px',
                }}
              >
                {languages.map((lang) => (
                  <button
                    key={lang.code}
                    onClick={() => {
                      i18n.changeLanguage(lang.code);
                      setShowLangDropdown(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '6px 10px',
                      border: 'none',
                      background: i18n.language === lang.code ? '#3498db' : '#fff',
                      color: i18n.language === lang.code ? '#fff' : '#000',
                      cursor: 'pointer',
                      textAlign: 'left',
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0d3550ff', e.currentTarget.style.color = '#fff')}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = i18n.language === lang.code ? '#0f3b58ff' : '#fff';
                      e.currentTarget.style.color = i18n.language === lang.code ? '#fff' : '#000';
                    }}
                  >
                    {lang.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* เส้นขีดยาวใต้ปุ่ม */}
      <div style={{ height: '1px', backgroundColor: '#ddd', width: '100%', marginTop: '8px', marginBottom: '10px' }} />

      {/* วันโพสต์ + ป้ายสถานะ */}
      {diffDays !== null && (
        <div
          style={{
            marginTop: '10px',
            color: '#777',
            fontSize: '0.9rem',
            textAlign: 'right',
            marginRight: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '6px',
            flexWrap: 'wrap',
          }}
        >
          <Clock size={16} />
          <span>
            {t("Posted")} : {new Date(selectedProperty.created_at).toLocaleDateString()}
          </span>
        </div>
      )}

      <div
        style={{
          marginTop: '-20px',
          color: '#777',
          fontSize: '0.9rem',
          textAlign: 'left',
          marginRight: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '6px',
          flexWrap: 'wrap',
        }}
      >
        <div>
          {selectedProperty.featured && <span style={styles.hotDealInline}>🔥 {t("Hot Deal")}</span>}
          {selectedProperty.furnished && <span style={styles.furnishedInline}>{t("Furnished_full")}</span>}
          <span
            style={{
              ...styles.statusInline,
              backgroundColor:
                selectedProperty.status === "Buy"
                  ? "#F39C12"
                  : selectedProperty.status === "Rent"
                  ? "#3498db"
                  : selectedProperty.status === "Rented" || selectedProperty.status === "Sold Out"
                  ? "#E74C3C"
                  : "#bdc3c7",
            }}
          >
            {t(selectedProperty.status || "Available")}
          </span>
        </div>
      </div>
    </>
  );
};

const styles = {
  hotDealInline: {
    background: 'linear-gradient(135deg, #ffa733, #ff6b00, #cc5200)',
    color: '#fff',
    padding: '2px 6px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: 'bold',
    marginLeft: '6px',
  },
  furnishedInline: {
    background: 'linear-gradient(90deg, #1a8cff, #0a71e7)',
    color: '#fff',
    padding: '2px 6px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: 'bold',
    marginLeft: '6px',
  },
  statusInline: {
    color: '#fff',
    padding: '4px 8px',
    borderRadius: '8px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    marginLeft: '6px',
  },
};

export default DetailModalHeader;
